import React from "react";
import { Outlet } from "react-router-dom";


const Substitutions = () => {
    return (
        <Outlet />
    )
};

export default Substitutions;
